// src/Components/Functions/printUtils.js

export const printContent = (contentRef, options = {}) => {
    const {
      title = 'Document',
      subtitle = '',
      pageSize = 'A4', // Default to A4, can be 'Letter', 'A3', etc.
      orientation = 'portrait', // Default to portrait, can be 'landscape'
    } = options;
  
    if (!contentRef || !contentRef.current) {
      console.error('Invalid or missing content reference');
      return false;
    }
  
    try {
      // Create a new container for printing
      const printContainer = document.createElement('div');
      printContainer.style.backgroundColor = 'white';
      printContainer.style.padding = '10mm'; // Reduced padding for more content space
      printContainer.style.fontFamily = 'Arial, sans-serif';
      printContainer.style.width = '100%';
      printContainer.style.boxSizing = 'border-box';
  
      // Add title and optional subtitle
      const header = document.createElement('div');
      header.style.marginBottom = '10px';
      header.style.textAlign = 'center';
      header.innerHTML = `
        <h1 style="font-size: 20px; margin: 0 0 5px 0;">${title}</h1>
        ${subtitle ? `<p style="font-size: 12px; color: #555; margin: 0;">${subtitle}</p>` : ''}
      `;
      printContainer.appendChild(header);
  
      // Clone the content from the ref
      const content = contentRef.current.cloneNode(true);
  
      // Adjust styles for printing
      const tables = content.querySelectorAll('table');
      tables.forEach((table) => {
        table.style.width = '100%'; // Fit table to page width
        table.style.maxWidth = '100%';
        table.style.borderCollapse = 'collapse';
        table.style.fontSize = '10px'; // Smaller font to fit more content
        table.style.tableLayout = 'auto'; // Allow columns to adjust naturally
        table.style.wordBreak = 'break-word'; // Break long words if needed
  
        const cells = table.querySelectorAll('td, th');
        cells.forEach((cell) => {
          cell.style.border = '1px solid #ccc';
          cell.style.padding = '4px'; // Reduced padding for compactness
          cell.style.whiteSpace = 'normal'; // Allow text wrapping
          cell.style.wordWrap = 'break-word';
          cell.style.maxWidth = '0'; // Prevent overflow, allow wrapping
          cell.style.overflow = 'hidden';
        });
  
        // Ensure headers repeat on each page
        const thead = table.querySelector('thead');
        if (thead) {
          thead.style.display = 'table-header-group';
        }
      });
  
      printContainer.appendChild(content);
  
      // Create a hidden iframe for printing
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);
  
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>${title}</title>
            <style>
              @media print {
                body { 
                  margin: 0; 
                  padding: 0; 
                  font-size: 10pt;
                }
                @page { 
                  size: ${pageSize} ${orientation}; 
                  margin: 15mm; 
                }
                table { 
                  page-break-inside: auto; 
                  width: 100%; 
                  break-inside: avoid;
                }
                tr { 
                  page-break-inside: avoid; 
                  page-break-after: auto; 
                }
                thead { 
                  display: table-header-group; 
                }
                tfoot { 
                  display: table-footer-group; 
                }
                /* Ensure content doesn't overflow */
                * { 
                  box-sizing: border-box; 
                  overflow-wrap: break-word; 
                }
              }
            </style>
          </head>
          <body>
            ${printContainer.outerHTML}
          </body>
        </html>
      `);
      doc.close();
  
      // Trigger print
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
  
      // Clean up
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000); // Delay cleanup to ensure print dialog appears
  
      return true;
    } catch (error) {
      console.error('Error during printing:', error);
      return false;
    }
  };